var exports = {
  "f": "accent__X0alGg",
  "hZ": "trigger__yjdxA5",
  "aQ": "triggerContent__sKFmOu",
  "F": "counterLoading__4XUw8S",
};

module.exports = exports;
